import { z } from 'zod';
import { reportTypeSchema } from './report-type.schema';

export const createJobRequestSchema = z.object({
	reportType: reportTypeSchema,
	parameters: z.unknown(),
});

export type CreateJobRequest = z.infer<typeof createJobRequestSchema>;
